import React from "react";

const StickyList = ({ data }) => {
    return (
        data?.map((val, idx) => (
            <div
                className="group sticky top-20 md:top-[112px] rounded-[20px] md:rounded-[30px] flex flex-col md:flex-row min-h-[280px] bg-[#E4F0FF] hover:bg-[#3067A7] border border-[#034694] duration-300"
                key={idx}
            >
                <div className="flex flex-col justify-center gap-4 pt-2 pb-6 md:pb-2 mx-auto w-[80%] md:w-[50%] min-h-[185px] md:min-h-auto">
                    <p className="text-[20px] md:text-[30px] font-bold text-[#034694] pt-4 md:pt-0 group-hover:text-[#FFFFFF]">
                        {val?.label}
                    </p>
                    <p className="font-normal text-xs md:text-base w-full md:w-[80%] text-[#034694] group-hover:text-[#FFFFFF]">
                        {val?.desc}
                    </p>
                </div>

                <div
                    className="rounded-ee-[20px] md:rounded-ee-[30px] rounded-es-[20px] md:rounded-es-[0px] rounded-se-[0px] md:rounded-se-[30px] bg-slate-600 w-full md:w-[35%] h-[180px] md:h-auto"
                    style={{
                        backgroundImage: `url(${val?.img})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat'
                    }}
                />
            </div>
        ))
    )
}

export default StickyList;